import { render, staticRenderFns } from "./Index-Navigation.vue?vue&type=template&id=fc36ce54"
import script from "./Index-Navigation.vue?vue&type=script&lang=js"
export * from "./Index-Navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports